import _ from "lodash";
import DebugLogger from "../../../../utils/DebugLogger";
import DynamicServiceHelper from "./DynamicServiceHelper";
import HmacSHA256 from "crypto-js/hmac-sha256";
import Base64 from "crypto-js/enc-base64";
import Constants from "../../../../../config/Constants";

const TAG = "RNSpeechRecognize XFIAT";
const HostUrl = "wss://iat-api.xfyun.cn/v2/iat";

export default class XunFeiIATSpeechRecognitionService {
    TIMEOUT_SECONDS = 180;

    appId = "";
    apiSecret = "";
    apiKey = "";
    punc = false;
    nunum = "";
    useProxy = false;
    proxyAddress = "";
    lang = "";

    //for now it is generate by java code, if we use this, we should generate token in the server side.
    token = null;
    expireTime = 0;
    timestamp = 0;
    ws = null;
    resultText = "";
    resultTextTemp = "";

    streamSendingError = false;
    realTimeVoiceDataWriter = null;

    tmpReferenceText = null;
    tmpCallback = null;
    isRecording = false; // we will not throw exception/reject promise when recording for stream request
    buffer = null;

    constructor(configMap) {
        this.apiSecret = configMap.apiSecret;
        this.appId = configMap.appId;
        this.apiKey = configMap.apiKey;
        //标点过滤控制，默认返回标点，punc=0会过滤结果中的标点
        if (_.has(configMap, "punc")) {
            this.punc = configMap.punc === "1";
        }
        if (_.has(configMap, "nunum")) {
            //将返回结果的数字格式规则为阿拉伯数字格式, 默认关闭
            this.nunum = configMap.nunum === "1";
        }
        if (_.has(configMap, "useProxy")) {
            this.useProxy = configMap.useProxy;
        }
        if (_.has(configMap, "proxyAddress")) {
            this.proxyAddress = configMap.proxyAddress;
        }

        if (_.has(configMap, "lang")) {
            this.lang = configMap.lang;
        }
    }

    Recognize(referenceText, wav, callback) {
        //start request.
        DebugLogger.log(TAG, "ajax call start");
        const requestUrl = this.GenerateUrl(HostUrl, this.apiKey, this.apiSecret);
        const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 3, this.useProxy, this.proxyAddress);
        this.buffer = null;
        this.resultText = "";
        this.tmpCallback = callback;
        wav.arrayBuffer()
            .then(audioContent => {
                this.buffer = new Int8Array(audioContent, 44); //skip top 44 wav header;
                if ("WebSocket" in window) {
                    this.ws = new WebSocket(finalUrl);
                } else if ("MozWebSocket" in window) {
                    this.ws = new window.MozWebSocket(finalUrl);
                } else {
                    throw new Error("浏览器不支持WebSocket");
                }

                this.ws.onopen = e => {
                    setTimeout(() => {
                        this.wsOpened(e);
                    }, 500);
                    //this.config.onStart && this.config.onStart(e);
                };
                this.ws.onmessage = e => {
                    // this.config.onMessage && this.config.onMessage(e)
                    this.wsOnMessage(e);
                };
                this.ws.onerror = e => {
                    //this.stop();
                    DebugLogger.log("关闭连接ws.onerror");
                    //this.config.onError && this.config.onError(e);
                    callback.onFailure("Error", e != null ? e.message : "connect fail");
                };
                this.ws.onclose = e => {
                    //this.stop();
                    DebugLogger.log("关闭连接ws.onclose");
                    //this.config.onClose && this.config.onClose(e);
                };
            })
            .catch(err => {
                DebugLogger.log("_postFileApi err", err);
                callback.onFailure("Error", err.message);
            });
    }

    BeforeSendVoiceData(referenceText, callback) {
        throw new Error("recognize with record is not supported");
    }

    SendVoiceData(voiceData, offset, length) {
        //if error in stream request, we just do not send anymore
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            try {
                this.realTimeVoiceDataWriter.write(voiceData, offset, length);
            } catch (ex) {
                this.streamSendingError = true;
                DebugLogger.log(TAG, "SendVoiceData Error:");
                DebugLogger.log(TAG, ex.message);
            }
        }
    }

    AfterSendVoiceData(wav) {
        this.isRecording = false;
        DebugLogger.log(TAG, "AfterSendVoiceData");
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            DebugLogger.log(TAG, "AfterSendVoiceData Normal Case");
            this.realTimeVoiceDataWriter.stop();
            this.realTimeVoiceDataWriter = null;
        } else {
            DebugLogger.log(TAG, "AfterSendVoiceData Bad Case");
            this.Recognize(this.tmpReferenceText, wav, this.tmpCallback);
        }
    }

    IsErrorWhenSendingStream() {
        return this.streamSendingError;
    }

    NeedSendWavHeaderInNetworkStream() {
        return true;
    }

    destroy() {
        //nothing to do
        this.ws.close(1000);
    }

    GenerateUrl(hostUrl, apiKey, apiSecret) {
        const host = "iat-api.xfyun.cn";
        const date = new Date().toUTCString();
        const algorithm = "hmac-sha256";
        const headers = "host date request-line";
        const signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
        const signatureSha = HmacSHA256(signatureOrigin, apiSecret);
        const signature = Base64.stringify(signatureSha);
        const authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
        const authorization = btoa(authorizationOrigin);
        return `${hostUrl}?authorization=${authorization}&date=${date}&host=${host}`;
    }

    wsOpened() {
        if (this.ws.readyState !== 1) {
            return;
        }
        const chunkSize = 1280 * 5;
        let currentArrayIndex = 0;
        const audioData = this.buffer.slice(currentArrayIndex, currentArrayIndex + chunkSize);
        currentArrayIndex += chunkSize;
        const langCode = this.lang === Constants.SPEECH_LANG.en ? "en_us" : "zh_cn";
        const params = {
            common: {
                app_id: this.appId,
            },
            business: {
                language:  langCode, //小语种可在控制台--语音听写（流式）--方言/语种处添加试用
                domain: "iat",
                accent: "mandarin", //中文方言可在控制台--语音听写（流式）--方言/语种处添加试用
                vad_eos: 10000,
                ptt: this.punc ? 0 : 1,
                nunum: this.nunum ? 1 : 0,
                //dwa: 'wpgs', //为使该功能生效，需到控制台开通动态修正功能（该功能免费）
            },
            data: {
                status: 0,
                format: "audio/L16;rate=16000",
                encoding: "raw",
                audio: this.ArrayBufferToBase64(audioData),
            },
        };
        this.ws.send(JSON.stringify(params));
        this.handlerInterval = setInterval(() => {
            // websocket未连接
            if (this.ws.readyState !== 1) {
                clearInterval(this.handlerInterval);
                return;
            }
            if (this.buffer.length <= currentArrayIndex) {
                this.ws.send(
                    JSON.stringify({
                        data: {
                            status: 2,
                            format: "audio/L16;rate=16000",
                            encoding: "raw",
                            audio: "",
                        },
                    })
                );
                console.log("发送结束标识");
                clearInterval(this.handlerInterval);
                return false;
            }
            const audioData2 = this.buffer.slice(currentArrayIndex, currentArrayIndex + chunkSize);
            currentArrayIndex += chunkSize;
            if (audioData2.length > 0) {
                // 中间帧
                this.ws.send(
                    JSON.stringify({
                        data: {
                            status: 1,
                            format: "audio/L16;rate=16000",
                            encoding: "raw",
                            audio: this.ArrayBufferToBase64(audioData2),
                        },
                    })
                );
            }
        }, 40);
    }

    wsOnMessage(e) {
        let jsonData = JSON.parse(e.data);
        if (jsonData.data && jsonData.data.result) {
            let data = jsonData.data.result;
            let str = "";
            let resultStr = "";
            let ws = data.ws;
            for (let i = 0; i < ws.length; i++) {
                str = str + ws[i].cw[0].w;
            }
            // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
            // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
            if (data.pgs) {
                if (data.pgs === "apd") {
                    // 将resultTextTemp同步给resultText
                    this.resultText = this.resultTextTemp;
                }
                // 将结果存储在resultTextTemp中
                this.resultTextTemp = this.resultText + str;
            } else {
                this.resultText += str;
            }
            DebugLogger.log(TAG, "中间识别结果 ==》" + this.resultText.toString());
        }
        if (jsonData.code === 0 && jsonData.data.status === 2) {
            this.ws.close();
             DebugLogger.log(TAG, "sid:" + jsonData.data.sid + " 最终识别结果" + this.resultText);
            if (this.tmpCallback != null) {
                this.tmpCallback.onSuccess("", this.resultText);
                this.tmpCallback = null;
            }
        }
        if (jsonData.code !== 0) {
            this.ws.close();
            const errMsg = "code=>" + jsonData.code + " error=>" + jsonData.message + " sid=" + jsonData.sid;
            DebugLogger.log(TAG, errMsg);
            //Log.i(TAG,"错误码查询链接：https://www.xfyun.cn/document/error-code");
            if (this.tmpCallback != null) {
                this.tmpCallback.onFailure("Error", errMsg);
                this.tmpCallback = null;
            }
        }
    }

    ArrayBufferToBase64(buffer) {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    getContent(data) {
        let tmpResult = "";
        if (data.cn.st.type === 0) {
            data.cn.st.rt.forEach(j => {
                j.ws.forEach(k => {
                    k.cw.forEach(l => {
                        tmpResult += l.w;
                    });
                });
            });
        }
        return tmpResult;
    }
}
